import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';

enum IconType {
  cart = 'cart',
  user = 'user',
  listMenu = 'listMenu',
}

interface Props {
  icon: IconType;
  className?: string;
  viewBox?: string;
  fill?: string;
  title?: string;
  alt?: string;
  cursor?: string;
  marginLeft?: number;
  marginRight?: number;
  height?: number;
  width?: number;
  onClick?: any;
  rotate?: number;
}

const icons = {
  cart: () => (
    <path
      d="M30.9,10.5l-3.4-3.4c-0.4-0.4-1-0.4-1.4,0l-1,1l-4.4,4.4l-1.2-1.2L23,7.8l0,0L24.8,6l0,0l0,0l0.1-0.1
      c0.4-0.4,0.4-1,0-1.4l-3.4-3.4c-1.5-1.4-3.8-1.4-5.3,0c-0.9,0.9-0.9,2.4,0,3.3l0,0l3.4,3.4C19.7,7.9,19.8,8,19.9,8l-1.7,1.8L16,7.7
      c-0.4-0.4-1-0.4-1.4,0c0,0,0,0,0,0l-6.8,6.8c-1.3,0-2.6,0.6-3.5,1.6c-1,0.9-1.6,2.2-1.6,3.6l-2,2c-1,1-1,2.5,0,3.5l6.1,6.2
      C7.3,31.7,7.9,32,8.6,32c0.7,0,1.3-0.3,1.8-0.7l1.6-1.7c1.2,1.1,2.8,1.8,4.5,1.9c1.6,0,3.1-0.7,4.1-1.9l4.8-4.8
      c0.8-0.8,0.7-2.1-0.1-2.9l0,0L22.5,19l1.7-1.7c0.4-0.4,0.4-1,0-1.4l-2-2l1.7-1.8c0.1,0.1,0.1,0.2,0.2,0.3l3.4,3.4l0,0
      c0.9,0.9,2.4,0.9,3.3,0c0,0,0,0,0,0C32.4,14.3,32.4,12,30.9,10.5z M21,6.4L17.7,3c-0.1-0.1-0.1-0.4,0-0.5c0.7-0.7,1.8-0.7,2.4,0
      l2.7,2.7l-1.2,1.2C21.5,6.5,21.3,6.6,21,6.4C21.1,6.5,21.1,6.4,21,6.4z M15.3,9.8l6.8,6.8l-1.3,1.3l-10.6-3L15.3,9.8z M4.7,19.5
      c0-0.3,0-1,1.1-2.1c0.6-0.6,1.4-1,2.2-1c0.1,0,0.1,0,0.2,0l11,3.1L12,26.8L4.7,19.5z M8.9,29.8C8.8,29.9,8.7,30,8.6,30
      c-0.1,0-0.2,0-0.3-0.1l-6.1-6.2c-0.2-0.2-0.2-0.5,0-0.7l1.6-1.6l6.8,6.8L8.9,29.8z M23.9,23.3c0.1,0.1,0.1,0.1,0.1,0.1l-4.8,4.8
      c-0.7,0.8-1.7,1.3-2.7,1.3c-1.2-0.1-2.2-0.5-3.1-1.3l7.7-7.7L23.9,23.3z M29.5,14.4c-0.1,0.1-0.3,0.2-0.4,0.1c0,0-0.1-0.1-0.1-0.1
      L25.6,11c-0.1-0.1-0.1-0.4,0-0.5l1.2-1.2l2.7,2.7C30.2,12.6,30.2,13.7,29.5,14.4L29.5,14.4z"
    />
  ),
  user: () => (
    <path
      d="M29.9,15.5c-0.4-0.6-1-1.1-1.8-1.3l0.1-0.6c0.2-1.8,0.1-3.6-0.5-5.4c-0.4-1.2-1.1-2.3-2-3.2l0.8-2.3c0.4-1-0.2-2.2-1.2-2.5
      C25.1,0.1,24.9,0,24.7,0c0,0-1.7,0-3.8,0l0,0c-2.6-0.1-5.2,0-7.8,0.2C11.6,0.4,10,0.8,8.6,1.5c-2,1-3.4,2.8-4.2,4.8
      c-0.3,1-0.6,2.1-0.7,3.1c-0.2,1.3-0.2,2.7,0,4.1l0.1,0.6c-0.7,0.2-1.4,0.7-1.8,1.3c-0.5,0.8-0.7,1.7-0.5,2.6c0.2,1,0.6,1.9,1.3,2.7
      c0.5,0.6,1.3,1,2.1,1c0.2,0,0.5,0,0.7-0.1l0.1,0c0.3,1,0.7,2,1.2,3c1.1,2.4,2.9,4.5,5.2,6c1.1,0.7,2.3,1.2,3.6,1.3
      c0.1,0,0.3,0,0.4,0c1.3,0,2.5-0.4,3.5-1.1c2.3-1.4,4.1-3.4,5.3-5.8c0.6-1.1,1-2.2,1.4-3.4c0.3,0.1,0.5,0.1,0.8,0.1
      c1,0,2-0.6,2.4-1.5l0.1-0.2c0.3-0.6,0.6-1.2,0.8-1.9C30.6,17.3,30.5,16.3,29.9,15.5z M28.4,17.7c-0.2,0.6-0.5,1.2-0.8,1.7
      c-0.1,0.3-0.4,0.4-0.6,0.4c-0.1,0-0.2,0-0.3,0c-0.5-0.2-1.1-0.3-1.6-0.4c0,0-0.1,0-0.1,0c-0.2,0-0.2,0.1-0.3,0.3
      c-0.3,1.6-0.9,3.1-1.6,4.5c-1,2.1-2.6,3.8-4.6,5.1C17.8,29.7,16.9,30,16,30c-0.1,0-0.2,0-0.3,0c-0.9-0.1-1.9-0.4-2.6-1
      c-1.9-1.3-3.5-3.1-4.5-5.2c-0.6-1.1-1-2.3-1.3-3.6c-0.1-0.2-0.1-0.4-0.2-0.6c0-0.2-0.1-0.2-0.3-0.2c0,0-0.1,0-0.1,0
      c-0.6,0.1-1.1,0.3-1.7,0.4c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4-0.1-0.5-0.3C4,19,3.7,18.4,3.5,17.7c-0.2-0.7,0.2-1.4,0.9-1.6
      c0.1,0,0.1,0,0.2,0C4.9,16,5.3,16,5.6,16C5.9,16,6,15.8,6,15.5c-0.1-0.7-0.2-1.5-0.2-2.2c-0.1-1.2-0.1-2.4,0-3.6
      C5.8,8.8,6,7.9,6.3,7.1c0.5-1.6,1.7-3,3.2-3.8c1.2-0.6,2.5-1,3.9-1.1C14.5,2,18.1,2,20.9,2c1.5,0,2.7,0,3.4,0c0,0,0,0,0,0.1
      c-2.3,8.8-13.3,6.6-13.8,6.5C9.9,8.5,9.4,8.8,9.3,9.3s0.2,1.1,0.8,1.2c1.2,0.2,2.5,0.4,3.7,0.4c3.6,0,7.9-1,10.6-4.5
      c0.7,0.6,1.2,1.5,1.5,2.4c0.5,1.5,0.6,3,0.4,4.6c-0.1,0.7-0.2,1.4-0.2,2.1c0,0.4,0,0.5,0.4,0.5c0.3,0,0.7,0.1,1,0.1
      c0.7,0.1,1.2,0.7,1.1,1.4C28.5,17.5,28.5,17.6,28.4,17.7z M12,14.5c-0.8,0-1.5,0.6-1.5,1.4c0,0,0,0.1,0,0.1c0,0.8,0.7,1.5,1.5,1.5
      c0.8,0,1.5-0.6,1.5-1.5S12.9,14.5,12,14.5L12,14.5L12,14.5z M20,14.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5
      c0,0,0,0,0,0c0-0.8-0.6-1.5-1.4-1.5C20,14.5,20,14.5,20,14.5z"
    />
  ),
  listMenu: () => (
    <path d="M24,4H0V2h24V4z M24,11H0v2h24V11z M24,20H0v2h24V20z" />
  ),
};

function SvgIcon({
  icon,
  className,
  viewBox = '0 0 32 32',
  fill,
  cursor,
  title = '',
  alt = '',
  marginLeft = 0,
  width = 32,
  height = 32,
  marginRight = 0,
  onClick = null,
  rotate,
}: Props) {
  const IconSrc: any = icons[icon];

  return (
    <IconWrapper
      cursor={cursor}
      fill={fill}
      className={className}
      viewBox={viewBox}
      onClick={onClick}
      marginLeft={marginLeft}
      marginRight={marginRight}
      width={width}
      height={height}
      rotate={rotate}
    >
      <title id="idTitle">{title}</title>
      <desc id="idDesc">{alt}</desc>
      <IconSrc />
    </IconWrapper>
  );
}

const IconStyles = css`
  vertical-align: middle;
`;

const IconWrapper = styled.svg<{
  fill?: string;
  cursor?: string;
  marginLeft: number;
  marginRight: number;
  width: number;
  height: number;
  rotate?: number;
}>`
  ${IconStyles};
  fill: ${({ theme, fill }) => (fill ? fill : theme.colors.primary)};
  cursor: ${({ cursor }) => (cursor ? cursor : 'initial')};
  transition: fill 0.2s ease, transform 0.2s ease;
  margin-left: ${props => rem(props.marginLeft)};
  margin-right: ${props => rem(props.marginRight)};
  width: ${props => rem(props.width)};
  height: ${props => rem(props.height)};
  transform: ${({ rotate }) => (rotate ? `rotate(${rotate}deg)` : 'none')};
`;

const IconPath = styled.path``;
export { IconType, SvgIcon };
